import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface ETAEstimatorProject extends Project {
  flow: flowConfig.FLOW_TYPE;
  data_file: {
    [flowConfig.INPUT_DATA]: string;
    [flowConfig.AUGMENTED_FILE]?: string;
  };
  meta_data: {
    [flowConfig.ORIGIN_LAT_KEY]: string;
    [flowConfig.ORIGIN_LONG_KEY]: string;
    [flowConfig.DEST_LAT_KEY]: string;
    [flowConfig.DEST_LONG_KEY]: string;
    [flowConfig.START_TIME_KEY]: string;
    [flowConfig.END_TIME_KEY]: string;
    [flowConfig.DURATION_KEY]?: string;
  };
}

export const projectIsETAEstimator = (
  project: Project
): project is ETAEstimatorProject => project.flow === flowConfig.FLOW_NAME;

export type ModelAnnotationsInterface = {
  url: string;
  [flowConfig.RUN_ID]: string;
  [flowConfig.INIT_RUN]: boolean;
  [flowConfig.CREATED_BY]: string;
  [flowConfig.TIME_STAMP]: number;
};
